import * as stylex from "@stylexjs/stylex";
import {
  spacing,
  colors,
  fontSizes,
  radii,
} from "@softmax/design-system/tokens.stylex";
export const localStyles = stylex.create({
  sidebar: {
    order: { default: 2, "@media (min-width: 768px)": 1 },
    minWidth: 0,
  },
  filter: { display: "block", marginTop: spacing.space12 },
  pageList: {
    display: "flex",
    flexDirection: "column",
    marginTop: spacing.space12,
    paddingTop: spacing.space8,
    borderTopWidth: 1,
    borderTopStyle: "solid",
    borderTopColor: colors.border,
  },
  navHeight: (height: number) => ({ minHeight: height }),
  pageLink: {
    display: "block",
    padding: spacing.space8,
    color: { default: colors.muted, ":hover": colors.foreground },
    fontSize: fontSizes.small,
    lineHeight: 1.4,
    borderRadius: radii.small,
    textDecoration: "none",
    overflowWrap: "anywhere",
    backgroundColor: { default: "transparent", ":hover": colors.hover },
    outline: {
      default: "none",
      ":focus-visible": `2px solid ${colors.foreground}`,
    },
    outlineOffset: 2,
  },
  activePage: {
    backgroundColor: colors.surfaceAlt,
    color: colors.foreground,
    fontWeight: 500,
  },
  srOnly: {
    position: "absolute",
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clipPath: "inset(50%)",
    whiteSpace: "nowrap",
    borderWidth: 0,
  },
});
